"use client";

import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GetInformedNow() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="124323" id="χρειάζεστε-άμεση-υποστήριξη" className="dark bg-background text-foreground relative overflow-hidden">
      {}
      <div className="absolute inset-0 bg-background" aria-hidden="true" />

      {}
      <div className="absolute inset-0 opacity-5 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1628303/img/noise_texture_cta.png')] mix-blend-overlay pointer-events-none" aria-hidden="true" />

      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-4 py-16 md:py-24 text-center transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-foreground mb-6 font-default tracking-tight">
          Χρειάζεστε άμεση υποστήριξη;
        </h2>
        
        <p className="text-lg md:text-xl text-muted-foreground mb-10 font-sans max-w-2xl mx-auto leading-relaxed">
          Εξειδικευμένη υποστήριξη και καθοδήγηση για κάθε στάδιο της καριέρας σας. 
          Είμαστε δίπλα στον Έλληνα ένστολο με υπευθυνότητα και απόλυτη εχεμύθεια.
        </p>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button asChild size="lg" className="bg-primary text-primary-foreground hover:bg-primary/90 border-none w-full sm:w-auto font-medium shadow-md rounded-sm">
            
          </Button>
          
          <Button asChild variant="outline" size="lg" className="border-primary text-primary bg-transparent hover:bg-primary/10 hover:text-primary w-full sm:w-auto font-medium rounded-sm">
            
          </Button>
        </div>
      </div>
    </section>;
}